import { graphql, useStaticQuery } from 'gatsby';

export const useLiveStatus = (): Queries.Maybe<Queries.Squidex_LiveStatus> => {
  const data = useStaticQuery<Queries.Query>(query);

  return data.squidex.findLiveStatusSingleton;
};

const query = graphql`
  query useLiveStatusQuery {
    squidex {
      findLiveStatusSingleton {
        data {
          title {
            de
            en
          }
          label {
            de
            en
          }
          description {
            de
            en
          }
          weatherTitle {
            de
            en
          }
          weatherOverall {
            de
            en
          }
          weatherMetaInfo {
            de
            en
          }
          weatherOverTheDay {
            de
            en
          }
          weatherMorning {
            de
            en
          }
          weatherNoon {
            de
            en
          }
          weatherEvening {
            de
            en
          }
          weatherForecast {
            de
            en
          }
          weatherTemperature {
            de
            en
          }
          weatherDate {
            de
            en
          }
          weatherStatus {
            de
            en
          }
          weatherRainfall {
            de
            en
          }
          weatherWind {
            de
            en
          }
          weatherSnowdepth {
            de
            en
          }
          weatherAvalanchestatus {
            de
            en
          }
          weatherNewsnow {
            de
            en
          }
          weatherSummary {
            de
            en
          }

          facilitiesTitle {
            de
            en
          }
          facilitiesClosed {
            de
            en
          }
          facilitiesOpened {
            de
            en
          }

          slopesTitle {
            de
            en
          }
          slopesClosed {
            de
            en
          }
          slopesOpened {
            de
            en
          }

          webcamsTitle {
            de
            en
          }
          webcamsDescription {
            de
            en
          }
        }
      }
    }
  }
`;
